import axios from 'axios';
import { reduceTokens } from '../../../Functions/ReduceTokens/ReduceTokens';
import { generatedOutreachAdd } from '../AddGeneratedOutreach';
 

export const JobRoleModel = (fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam) =>{
    
    let intVal = int
    let setContentGen = setContent

    // console.log('in work')
    let cta = callToAction?.length > 0 ? callToAction?.[0]?.CTA : 'Would you be open to a 20 min call to explore further?'
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib2R5Ijoic3R1ZmYiLCJpYXQiOjE2MjMxMDUyODR9.8EPq1VG9sw6Dafw9LclznDycHbdJC8wVO3Sqfi_jUMo'

    var input = `${vProp.Pain}\nValue: ${vProp.ValueProp}\nRole: ${intVal}.`
    const message= { Input: input }
    //first classify interest
    axios 
    .post('https://boundapiv2.herokuapp.com/newJobRoleModel', message, { headers: {"Authorization" : `jwt ${token}`} })
    .then((response) => {
        let str = response.data
        str = str.substring(str.indexOf(":") + 1)
        
        let replaceContent= str
        let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
        let breaksGone = removePer.split('\n\n').slice(0,2).join('\n\n')
        let personalContent = breaksGone.trim();
        let type = 'Job Role Model'

        if(response.data.length > 220){
            reduceTokens(auth, tokens, teamToken,tokensTeam)
            let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
            setContentGen(output)
            
            
            generatedOutreachAdd(docID, fbProfile, output, vProp, int, type, setGenerating, auth, name)
            

        } else {
            axios.post('https://boundapiv2.herokuapp.com/newJobRoleModel', message)
            .then((response) =>{
                let str = response.data
                // console.log(str)
                str = str.substring(str.indexOf(":") + 1)
                // let replaceContent = response.data.replace("Output:", "")
                let replaceContent= str
                let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
                let breaksGone = removePer.split('\n\n').slice(0,2).join('\n\n')
                let personalContent = breaksGone.trim();
                let type = 'Job Role Model'

                if(response.data.length > 150){
                    reduceTokens(auth, tokens, teamToken,tokensTeam)
                    let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
                    setContentGen(output)

                    
                    generatedOutreachAdd(docID, fbProfile, output, vProp, int, type, setGenerating, auth, name)
                     

                } else {
                    let output = `Oops, sorry I went a little blank here. Happens to the best of us :)\n\nDon't worry no token was charged. Just press 'g' or hit the generate button and I'll be good to go again!`
                    setContentGen(output)

                    
                    generatedOutreachAdd(docID, fbProfile, output, vProp, int, type, setGenerating, auth, name)
                    
                }
            })
        }

    })
}